import { render } from "./EmailAttachments.vue?vue&type=template&id=18a4c7e8&scoped=true"
import script from "./EmailAttachments.vue?vue&type=script&lang=js"
export * from "./EmailAttachments.vue?vue&type=script&lang=js"

import "./EmailAttachments.vue?vue&type=style&index=0&id=18a4c7e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a4c7e8"]])

export default __exports__